import { render, staticRenderFns } from "./marketTzDetail.vue?vue&type=template&id=a092c58a&scoped=true"
import script from "./marketTzDetail.vue?vue&type=script&lang=js"
export * from "./marketTzDetail.vue?vue&type=script&lang=js"
import style0 from "./marketTzDetail.vue?vue&type=style&index=0&id=a092c58a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a092c58a",
  null
  
)

export default component.exports